import {
  FAILED,
  INPROGRESS,
  PREQUOTE,
  PRICED,
  QUOTESRETRIEVED,
  SUBMITTED,
  UNABLE,
  UNABLETOQUOTE,
  CLIENTERROR,
} from "@/constants/common.constants";
import moment from "moment";

export const quoteResponseToState = (quoteResponse) => {
  if (!quoteResponse || !quoteResponse.QuoteStatus) return PREQUOTE;
  const match = stateMapping.find(
    (s) => s.quoteStatus === quoteResponse.QuoteStatus
  );
  if (!match) return PREQUOTE;
  return match.outState;
};

export const quoteResponseToQuoteAccessId = (quoteResponse) => {
  if (!quoteResponse || !quoteResponse.QuoteRequestContinuationUri) return null;
  return getQuoteAccessIdFromUrl(quoteResponse.QuoteRequestContinuationUri);
};

export const getQuoteAccessIdFromUrl = (url) => {
  const urlObject = new URL(url);
  // Get the value of the accessId parameter from the continuation URL
  const accessId = urlObject.searchParams.get("quoteAccessId");
  return accessId;
};

export const isError = (quoteStatus) => {
  const errorStates = [UNABLE, FAILED, CLIENTERROR];
  return errorStates.includes(quoteStatus);
};

const stateMapping = [
  { quoteStatus: INPROGRESS, outState: PREQUOTE },
  { quoteStatus: QUOTESRETRIEVED, outState: PRICED },
  { quoteStatus: UNABLETOQUOTE, outState: UNABLE },
  { quoteStatus: SUBMITTED, outState: SUBMITTED },
];

export const findUserAnswer = (data, question) => {
  return data.find(
    (q) => q.InterfaceKey === question.InterfaceKey && q.Source !== "Default"
  );
};

export const findAnswer = (data, question) =>
  data.find((q) => q.InterfaceKey === question.InterfaceKey);

export const findMatchingOptionFromDependentQuestion = (data, question) => {
  for (const [optionId, conditionValue] of Object.entries(
    question.DependentValueCondition
  )) {
    if (!data.some((a) => conditionValue.some((c) => c === a.InterfaceKey))) {
      continue;
    }
    return question.Options?.find((x) => x.DataUiid === optionId)?.Value;
  }
};

export const isQuoteExpired = (selectedQuote) => {
  const quoteIsExpired =
    selectedQuote.QuoteStatus !== SUBMITTED &&
    selectedQuote.QuoteExpiryDate &&
    moment(selectedQuote.QuoteExpiryDate).utc().isBefore(moment().utc());
  return quoteIsExpired;
};

/**
 * Check whether the quote is annual requote and if user has confirmed eligibility of that quote
 * @param {{QuoteAdditionalData: {IsEligibilityConfirmed: boolean, IsAnnualRequote: boolean}}} quoteData - quote data.
 * @returns {boolean} - Boolean value indicates that the user has confirmed eligibility the annual requote
 */
export const hasNotConfirmedAnnualRequote = (quoteData = {}) => {
  const { QuoteAdditionalData: quoteAdditionalData } = quoteData;
  return (
    quoteAdditionalData &&
    quoteAdditionalData.IsAnnualRequote &&
    !quoteAdditionalData.IsEligibilityConfirmed
  );
};

export const hasNotConfirmedExpiredQuote = (quoteData = {}) => {
  const isExpiredQuote = isQuoteExpired(quoteData);
  const quoteAdditionalData = quoteData.QuoteAdditionalData;
  return (
    isExpiredQuote &&
    (!quoteAdditionalData || !quoteAdditionalData.IsExpiredQuoteConfirmed)
  );
};

/**
 * Check whether the confirm eligibility answer object has been answered
 * @param {{InterfaceKey: string, Value: string, Source: string}} answerObject - The eligibility answer object.
 * @returns {boolean} - Boolean value indicates that the user has answered the object
 */
export const hasConfirmedEligibility = (answerObject) => {
  return (
    answerObject &&
    answerObject.Value?.toLowerCase() === "true" &&
    answerObject.Source?.toLowerCase() === "user"
  );
};

/**
 * Check whether the confirm eligibility answer object has been answered
 * @param {{InterfaceKey: string, Value: string, Source: string}} answerObject - The eligibility answer object.
 * @param {{IsEligibilityConfirmed: boolean}} quoteAdditionalData - quote additional data.
 * @returns {boolean} - Boolean value indicates that the user has answered the object
 */
export const quoteConfirmedEligibility = (
  answerObject,
  quoteAdditionalData = {}
) => {
  return (
    hasConfirmedEligibility(answerObject) ||
    quoteAdditionalData.IsEligibilityConfirmed
  );
};

export const checkIfQuoteNeedShowEligibility = (
  eligibilityField,
  quoteData = {}
) => {
  const quoteAdditionalData = quoteData.QuoteAdditionalData ?? {};
  return (
    hasNotConfirmedAnnualRequote(quoteData) ||
    hasNotConfirmedExpiredQuote(quoteData) ||
    !quoteConfirmedEligibility(quoteData[eligibilityField], quoteAdditionalData)
  );
};
